import Vue from 'vue'
import { ActionTree, MutationTree } from 'vuex'
import { RootState } from '@/store/types'
import { AxiosResponse, AxiosError } from 'axios'
import cloneDeep from 'lodash/cloneDeep'
import moment from 'moment'
import { merge, unset } from 'lodash'

interface MessagesState {
  loaded: boolean;
  loading: boolean;
  fatalError: boolean;
  serverErrors: any;

  filter: any;

  lastMeta: {
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
  };

  documents: any[];
}

const $state: MessagesState = {
  loading: false,
  loaded: false,
  fatalError: false,
  serverErrors: null,

  filter: {},
  lastMeta: {
    page: 0,
    pageSize: 0,
    totalCount: 0,
    totalPages: 0,
  },

  documents: [],
}


const initState = cloneDeep($state)


export const $actions: ActionTree<MessagesState, RootState> = {
  loadData({ commit, state, rootState }, params) {
    const vm = (this as any)._vm
    commit('START_LOADING')
    return new Promise((resolve, reject) => {
      vm.$http
        .get(`/admins/rest/v1/admins/${rootState.actor.id}/messages`, { params })
        .then((response: AxiosResponse) => {
          commit('SET_ITEMS_LIST', response.data)
          commit('LOADED_SUCCESS')
          resolve(true)
        })
        .catch((error: AxiosError) => {
          // tslint:disable-next-line:no-console
          console.error('Fatal error', error.response?.data)
          commit('LOADED_ERROR')
          reject(error.response?.data)
        })
    })
  },
  markReaded({ commit, rootState }, row_id) {
    const vm = (this as any)._vm
    return new Promise((resolve, reject) => {
      vm.$http
        .patch(`/admins/rest/v1/admins/${rootState.actor.id}/messages/${row_id}`)
        .then((response: AxiosResponse) => {
          commit('SET_READED', response.data)
          resolve(true)
        })
        .catch((error: AxiosError) => {
          // tslint:disable-next-line:no-console
          console.error('Fatal error', error.response?.data)
          reject(error.response?.data)
        })
    })
  },
}

export const $mutations: MutationTree<MessagesState> = {
  RESET_STATE: (state) => {
    for (const key in initState) {
      (state as any)[key] = (initState as any)[key]
    }
  },
  START_LOADING: (state) => {
    state.loaded = false
    state.loading = true
    state.fatalError = false
  },
  LOADED_SUCCESS: (state) => {
    state.loaded = true
    state.loading = false
    state.fatalError = false
  },
  LOADED_ERROR: (state) => {
    state.loaded = true
    state.loading = false
    state.fatalError = true
  },
  SET_SERVER_ERROR: (state, errors) => {
    state.serverErrors = errors
  },
  SET_ITEMS_LIST(state, data) {
    console.log(data)
    state.documents = data.messages

    state.lastMeta = {
      page: data.meta.page,
      pageSize: data.meta.per_page,
      totalCount: data.meta.total_count,
      totalPages: data.meta.total_pages,
    }
  },
  SET_READED(state, data) {
    state.documents = state.documents.map((item: any) => {
      if (data.message.id === item.id) {
        item.readed_at = data.message.readed_at
      }
      return item
    })
  },
}

const $getters = {}

export const STORE_KEY = '$_messages'

export const store = {
  namespaced: true,
  state: $state,
  actions: $actions,
  getters: $getters,
  mutations: $mutations,
}
